export default "__VITE_ASSET__BVmNjgWq__"